import { observer } from "mobx-react";
import * as React from "react";

import { ListSafetyMessages } from "../ui/molecules/list-safety-messages";
import { ListCommandButtonsSafetyMessages } from "../ui/organisms/list-command-buttons-safety-messages";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import sizes from "../ui/sizes.scss";
import { articles } from "../help";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageSafetyMessagesSettings extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[
                    articles.adminChangeSafetyMessage,
                    articles.administratorFunctionalities,
                ]}
                breadcrumb={store.i18n.t("page.safetyMessagesSettings.title")}
                classic
            >
                <Section fill>
                    <ListSafetyMessages
                        commandBar={
                            <ListCommandButtonsSafetyMessages
                                listStateId={this.listStateId}
                                canDelete
                            />
                        }
                        listStateId={this.listStateId}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
